import { getService } from 'reducers/service';
import ServiceName from '../../shared/constants/serviceName';

export const getEvidenceDisposalRules = async (agencyID) => {
  const service = getService(ServiceName.rms_evidence_disposal_rules);

  const response = await service.find({
    query: {
      agencyID,
    },
  });

  return response || [];
};

export const createDisposalRule = async (agencyID, rule) => {
  const service = getService(ServiceName.rms_evidence_disposal_rules);

  return service.create(rule, {
    query: {
      agencyID,
    },
  });
};

export const updateDisposalRule = async (agencyID, ruleId, rule) => {
  const service = getService(ServiceName.rms_evidence_disposal_rules);

  return service.patch(ruleId, rule, {
    query: {
      agencyID,
    },
  });
};

export const deleteDisposalRule = async (agencyID, ruleId) => {
  const service = getService(ServiceName.rms_evidence_disposal_rules);

  return service.remove(ruleId, {
    query: {
      agencyID,
    },
  });
};

const evidenceDisposalRuleService = {
  getEvidenceDisposalRules,
  createDisposalRule,
  updateDisposalRule,
  deleteDisposalRule,
};

export default evidenceDisposalRuleService;
